(function() {
    'use strict';

    angular
        .module('app.centrosCosto')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/centros-costo',
                config: {
                    templateUrl: 'app/centrosCosto/list.html',
                    controller: 'centrosCosto.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-centro-costo/:id?',
                config: {
                    templateUrl: 'app/centrosCosto/edit.html',
                    controller: 'centrosCosto.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            }
        ];
    }
})();
